import type { User } from "firebase/auth";
import { getUserInfoWithLambda } from "~/services/server/user-tenant/getUserInfoWithLambda";
import type { LoadCookiesDataResult } from "./loadCookiesData";

/**
 * Resolve the current user's display username for loaders/actions without client Firestore.
 * Uses profile from cookies refresh when available; otherwise one loader/user API call.
 */
export async function resolveActorUserName(
  firebaseUser: User,
  cookies: LoadCookiesDataResult,
): Promise<string> {
  const fromCookies = cookies.profile?.username?.trim();
  if (fromCookies) return fromCookies;

  if (!cookies.didFetchUserLoader) {
    const userInfo = await getUserInfoWithLambda({ userID: firebaseUser.uid });
    const fromLambda = userInfo.profile?.username?.trim();
    if (fromLambda) return fromLambda;
  }

  return (
    firebaseUser.displayName?.trim() ||
    firebaseUser.email?.trim() ||
    ""
  );
}
